import './modal.css'

import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import classNames from 'classnames'
import React, { createRef, useEffect } from 'react'

import Box from '@mui/material/Box'

interface Props {
  children: any
  className?: string
  hideModal?: () => void
  isOpen?: boolean
  isSmall?: boolean
}

function Modal({ isOpen = true, className, isSmall, hideModal, children }: Props) {
  const modal = createRef() as any

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('modal-open')
      disableBodyScroll(modal.current)
    }

    return () => {
      clearAllBodyScrollLocks()
      // when adding support for opening modal from a modal: enableBodyScroll(this.modal.current)
      document.body.classList.remove('modal-open')
    }
  }, [modal, isOpen])

  return (
    <div
      aria-modal={isOpen}
      aria-labelledby="modal"
      role="dialog"
      className={classNames('modal', className, { 'is-small': isSmall, 'is-open': isOpen })}
    >
      <Box className="modal_background" onClick={hideModal} />
      <div className="modal_wrapper" ref={modal}>
        {children.type === 'div' ? children : React.cloneElement(children, { hideModal })}
      </div>
    </div>
  )
}

export default Modal
